import DashboardScreen from './dashboardScreen/DashboardScreen';
import MobileCommunityScreen from './mobileCommunityScreen/MobileCommunityScreen';
import ApiDocsScreen from './apiDocsScreen/ApiDocsScreen';
import { DashboardOutlined, UserOutlined, ExperimentOutlined, PartitionOutlined, ThunderboltOutlined, PictureOutlined, TeamOutlined, DeploymentUnitOutlined } from '@ant-design/icons';
import PlaygroundScreen from './playgroundScreen/PlaygroundScreen';
import WorkflowPlaygroundScreen from '../workflowPlaygroundScreen/WorkflowPlaygroundScreen';
import AccountScreen from './accountScreen/AccountScreen';
import SubAccountsScreen from './accountScreen/SubAccountsScreen';
import ModelDetailScreen from './modelDetailScreen/ModelDetailScreen';
import WorkflowDetailScreen from './workflowDetailScreen/WorkflowDetailScreen';
import ZenScreen from './zenScreen/ZenScreen';
import GalleryScreen from './galleryScreen/GalleryScreen';
import CreateScreen from './createScreen/CreateScreen';
import InvitationScreen from './accountScreen/InvitationScreen';
import BrandDnaScreen from './brandDnaScreen/BrandDnaScreen';
import BrandDnaDetailScreen from './brandDnaScreen/BrandDnaDetailScreen';
import BrandDnaExtractScreen from './brandDnaScreen/BrandDnaExtractScreen';
import BrandDnaDebugScreen from './brandDnaScreen/BrandDnaDebugScreen';
import BrandDnaCreateScreen from './brandDnaScreen/BrandDnaCreateScreen';
import BrandAssetsScreen from './brandDnaScreen/BrandAssetsScreen';
import BrandMoodboardsScreen from './brandDnaScreen/BrandMoodboardsScreen';
import BrandInvitationScreen from './brandDnaScreen/BrandInvitationScreen';
import BrandGenerationsScreen from './brandDnaScreen/BrandGenerationsScreen';
import ApiUsageScreen from './apiUsageScreen/ApiUsageScreen';
import AgentScreen from './agentScreen/AgentScreen';
import StudiosHomeScreen from './studiosScreen/StudiosHomeScreen';
import StudioDetailScreen from './studiosScreen/StudioDetailScreen';
import { RobotOutlined, AppstoreOutlined } from '@ant-design/icons';
import { Bot } from 'lucide-react';
import LlmPlaygroundScreen from './llmPlaygroundScreen/LlmPlaygroundScreen';

const routes = [
  {
    key: 'explore',
    title: 'Explore',
    component: <DashboardScreen />,
    icon: <DashboardOutlined />,
    permissions: ['view_dashboard'],
    path: '/explore',
    sidebar: true,
  },
  // Redirect old dashboard URL to explore
  {
    key: 'dashboard-redirect',
    title: 'Dashboard',
    component: <DashboardScreen />,
    icon: <DashboardOutlined />,
    permissions: ['view_dashboard'],
    path: '/dashboard',
    sidebar: false,
  },
  {
    key: 'zen',
    title: 'Zen',
    component: <ZenScreen />,
    icon: <ThunderboltOutlined />,
    permissions: ['view_playground'],
    path: '/zen',
    sidebar: true,
  },
  {
    key: 'zenModel',
    title: 'Zen',
    component: <ZenScreen />,
    permissions: ['view_playground'],
    path: '/zen/model/:modelId',
    sidebar: false,
  },
  {
    key: 'zenWorkflow',
    title: 'Zen',
    component: <ZenScreen />,
    permissions: ['view_playground'],
    path: '/zen/workflow/:workflowId',
    sidebar: false,
  },
  {
    key: 'gallery',
    title: 'Gallery',
    component: <GalleryScreen />,
    icon: <PictureOutlined />,
    permissions: ['view_dashboard'],
    path: '/gallery',
    sidebar: true,
  },
  {
    key: 'studios',
    title: 'Studios',
    component: <StudiosHomeScreen />,
    icon: <AppstoreOutlined />,
    permissions: ['view_dashboard'],
    path: '/studios',
    sidebar: true,
  },
  {
    key: 'studioDetail',
    title: 'Studio',
    component: <StudioDetailScreen />,
    permissions: ['view_dashboard'],
    path: '/studios/:slug',
    sidebar: false,
  },
  // {
  //   key: 'mediaLibrary',
  //   title: 'Media',
  //   component: <MediaLibraryScreen />,
  //   icon: <FolderOutlined />,
  //   permissions: ['view_dashboard'],
  //   path: '/media-library',
  //   sidebar: true,
  // },
  {
    key: 'brandDna',
    title: 'Brand DNA',
    component: <BrandDnaScreen />,
    icon: <DeploymentUnitOutlined />,
    permissions: ['view_dashboard'],
    path: '/brand-dna',
    sidebar: true,
  },
  {
    key: 'brandDnaCreate',
    title: 'Create Brand DNA',
    component: <BrandDnaCreateScreen />,
    permissions: ['view_dashboard'],
    path: '/brand-dna/new',
    sidebar: false,
  },
  {
    key: 'brandDnaDetail',
    title: 'Brand DNA',
    component: <BrandDnaDetailScreen />,
    permissions: ['view_dashboard'],
    path: '/brand-dna/:brandId',
    sidebar: false,
  },
  {
    key: 'brandDnaExtract',
    title: 'Brand DNA Extract',
    component: <BrandDnaExtractScreen />,
    permissions: ['view_dashboard'],
    path: '/brand-dna/:brandId/extract',
    sidebar: false,
  },
  {
    key: 'brandDnaDebug',
    title: 'Brand DNA Debug',
    component: <BrandDnaDebugScreen />,
    permissions: ['view_dashboard'],
    path: '/brand-dna/:brandId/debug',
    sidebar: false,
  },
  {
    key: 'brandAssets',
    title: 'Brand Assets',
    component: <BrandAssetsScreen />,
    permissions: ['view_dashboard'],
    path: '/brand-dna/:brandId/assets',
    sidebar: false,
  },
  {
    key: 'brandMoodboards',
    title: 'Brand Moodboards',
    component: <BrandMoodboardsScreen />,
    permissions: ['view_dashboard'],
    path: '/brand-dna/:brandId/moodboards',
    sidebar: false,
  },
  {
    key: 'brandGenerations',
    title: 'Brand Generations',
    component: <BrandGenerationsScreen />,
    permissions: ['view_dashboard'],
    path: '/brand-dna/:brandId/generations',
    sidebar: false,
  },
  {
    key: 'brandInvitation',
    title: 'Brand Invitation',
    component: <BrandInvitationScreen />,
    permissions: ['view_dashboard'],
    path: '/brand-invitation',
    sidebar: false,
  },
  {
    key: 'agent',
    title: 'AI Agent',
    component: <AgentScreen />,
    icon: <RobotOutlined />,
    permissions: ['view_dashboard'],
    path: '/agent',
    sidebar: true,
  },
  {
    key: 'agentThread',
    title: 'AI Agent',
    component: <AgentScreen />,
    permissions: ['view_dashboard'],
    path: '/agent/:threadId',
    sidebar: false,
  },
  {
    key: 'community',
    title: 'Community',
    component: <MobileCommunityScreen />,
    icon: <TeamOutlined />,
    permissions: ['view_dashboard'],
    path: '/community',
    sidebar: true,
  },
  {
    key: 'playground',
    title: 'Playground',
    component: <PlaygroundScreen />,
    icon: <ExperimentOutlined />,
    permissions: ['view_playground'],
    path: '/playground',
    sidebar: true,
    mobileHidden: true, // Hide from sidebar on mobile - use Zen instead
  },
  {
    key: 'workflowPlayground',
    title: 'Workflow Playground',
    component: <WorkflowPlaygroundScreen />,
    icon: <PartitionOutlined />,
    permissions: ['view_playground'],
    path: '/workflow-playground',
    sidebar: true,
    mobileHidden: true, // Hide from sidebar on mobile - use Zen instead
  },
  {
    key: 'llm-playground',
    title: 'LLM Playground',
    component: <LlmPlaygroundScreen />,
    icon: <Bot />,
    permissions: [],
    path: '/llm-playground',
    sidebar: true,
  },
  {
    key: 'account',
    title: 'Account',
    component: <AccountScreen />,
    icon: <UserOutlined />,
    permissions: ['view_dashboard'],
    path: '/account',
    sidebar: true,
  },
  {
    key: 'chat',
    title: 'AI Chat',
    component: <LlmPlaygroundScreen />,
    icon: <Bot />,
    permissions: [],
    path: '/chat',
    sidebar: true,
  },
  {
    key: 'docs',
    title: 'API & Docs',
    component: <ApiDocsScreen />,
    icon: <DeploymentUnitOutlined />,
    permissions: [],
    path: '/docs',
    sidebar: true,
  },
  {
    key: 'subAccounts',
    title: 'Sub-Accounts',
    component: <SubAccountsScreen />,
    permissions: ['view_dashboard'],
    path: '/sub-accounts',
    sidebar: false,
  },
  {
    key: 'modelDetail',
    title: 'Model Details',
    component: <ModelDetailScreen />,
    permissions: ['view_dashboard'],
    path: '/model/:modelId',
    sidebar: false,
  },
  {
    key: 'workflowDetail',
    title: 'Workflow Details',
    component: <WorkflowDetailScreen />,
    permissions: ['view_dashboard'],
    path: '/workflow/:workflowId',
    sidebar: false,
  },
  {
    key: 'create',
    title: 'Create',
    component: <CreateScreen />,
    permissions: ['view_dashboard'],
    path: '/create/:id',
    sidebar: false,
  },
  {
    key: 'apiUsage',
    title: 'API Usage',
    component: <ApiUsageScreen />,
    permissions: ['view_dashboard'],
    path: '/api-usage',
    sidebar: false,
  },
  {
    key: 'invitation',
    title: 'Invitation',
    component: <InvitationScreen />,
    permissions: ['view_dashboard'],
    path: '/invitation',
    sidebar: false,
  },
];

/**
 * Filters routes based on user permissions.
 * @returns {Array} Accessible routes
 */
export const getRoutes = () => {
  // const userPermissions = reduxStore.store.getState().auth.permissions;
  return routes;
  // return routes.filter((route) =>
  //   route.permissions.some((permission) =>
  //     userPermissions?.includes(permission)
  //   )
  // );
};

export default getRoutes;
